import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'

import { apiClient } from '@/services/apiClient'
import type {
  PersonaToolBindingsResponse,
  ToolBindingValue,
} from '@/types/toolFramework'

export function usePersonaToolBindings(
  personaId: string,
  opts?: { enabled?: boolean },
) {
  return useQuery({
    queryKey: ['toolBindings', personaId],
    queryFn: () =>
      apiClient.get<PersonaToolBindingsResponse>(
        `/api/personas/${personaId}/tool-bindings`,
      ),
    // Rides tool_framework like the capabilities/adapters catalogs.
    enabled: personaId !== '' && (opts?.enabled ?? true),
  })
}

export function useSetToolBinding() {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: ({
      personaId,
      capabilityId,
      ...body
    }: { personaId: string; capabilityId: string } & ToolBindingValue) =>
      apiClient.put<PersonaToolBindingsResponse>(
        `/api/personas/${personaId}/tool-bindings/${capabilityId}`,
        body,
      ),
    onSuccess: (_data, { personaId }) => {
      qc.invalidateQueries({ queryKey: ['toolBindings', personaId] })
    },
  })
}
